import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';
import { STATUS_LABEL, BRANCH_LABEL, CTA, READY_CLS, isOverdue, muted, primary } from './mbApi';
import { STAGE_LABEL, usePicName } from './HandoffControl';

export const WorkflowCard = ({ w, board, onOpen }) => {
  const picName = usePicName();
  const r = w.readiness || {};
  const [label, tab] = CTA[r.code] || ['Buka butiran', 'ringkasan'];
  const cids = new Set(board.creatives.filter((c) => c.workflow_id === w.id && !c.archived).map((c) => c.id));
  const nTests = board.tests.filter((t) => !t.archived && cids.has(t.creative_id)).length;
  const late = isOverdue(w);
  return (
    <div className="rounded-lg border border-[hsl(var(--border))] p-3 sm:p-4 space-y-1.5" data-testid={`mb-workflow-${w.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        {w.code && <span className="font-mono text-xs px-1.5 py-0.5 rounded bg-[#F77F00]/15 text-[#F77F00] shrink-0" data-testid={`mb-workflow-code-${w.id}`}>{w.code}</span>}
        <button onClick={() => onOpen(w.id, 'ringkasan')} aria-label={`Buka butiran ${w.code || w.title}`}
          className={`inline-flex items-center gap-0.5 text-sm ${muted} hover:text-[hsl(var(--primary))] min-h-10 px-1.5 rounded`} data-testid={`mb-expand-${w.id}`}>
          Buka butiran <ChevronRight size={16} />
        </button>
        {w.source_suggestion_id && <span className="text-xs px-1.5 py-0.5 rounded bg-sky-500/15 text-sky-400" data-testid={`mb-workflow-from-sugg-${w.id}`}>Dari cadangan AI</span>}
        {w.archived && <span className="px-1.5 py-0.5 rounded bg-white/10 text-xs" data-testid={`mb-workflow-archived-${w.id}`}>Arkib</span>}
      </div>
      <p className={`text-sm font-medium ${primary} break-words`} title={w.title}>{w.title}</p>
      <p className="text-sm" data-testid={`mb-readiness-${w.id}`}>
        <span className="text-[hsl(var(--primary))]">{STAGE_LABEL[w.current_stage || 'brief']} · {picName(w.current_pic_id)}</span>
        {' · '}<span className={READY_CLS(r)}>{r.label || '—'}</span>
      </p>
      {r.reason && (
        <p className={`text-xs ${muted}`} data-testid={`mb-next-action-${w.id}`}>
          {r.reason}{!r.ok && r.fixer_id && r.fixer_id !== w.current_pic_id ? ` · boleh dibetulkan oleh ${picName(r.fixer_id)}` : ''}
        </p>
      )}
      <div className="flex flex-wrap items-center justify-between gap-2 pt-1">
        <p className={`text-xs ${muted}`}>
          {BRANCH_LABEL[w.branch]} · {cids.size} versi · {nTests} ujian · Status papan: {STATUS_LABEL[w.status] || w.status}
          {w.deadline && <span className={late ? 'text-red-400' : ''} data-testid={`mb-deadline-${w.id}`}> · {late ? 'Lewat — due ' : 'Due '}{w.deadline}</span>}
        </p>
        <Button size="sm" className="h-10" onClick={() => onOpen(w.id, tab)} data-testid={`mb-cta-${w.id}`}>{label}</Button>
      </div>
    </div>
  );
};
